import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';

const { IconButton } = designSystem;

const StretchTrigger = ({ topPosition, leftPosition, rightPosition, isStretched, onMouseUp }) => (
  <div
    className="ws-stretch-trigger"
    style={{
      '--top': topPosition,
      '--left': leftPosition,
      '--right': rightPosition,
    }}
  >
    <IconButton
      appearance="light"
      size="medium"
      glyph={isStretched ? 'arrow-hw-in' : 'arrow-hw'}
      label={isStretched ? i18next.t('Unstretch') : i18next.t('Stretch')}
      tooltipProps={{
        placement: 'bottom',
      }}
      onMouseUp={onMouseUp}
    />
  </div>
);

StretchTrigger.propTypes = {
  topPosition: PropTypes.string.isRequired,
  leftPosition: PropTypes.string.isRequired,
  rightPosition: PropTypes.string.isRequired,
  isStretched: PropTypes.bool.isRequired,
  onMouseUp: PropTypes.func.isRequired,
};

export default StretchTrigger;
